import { makeAutoObservable, toJS } from "mobx";
import { IVehicleStore } from "./vehicleStore.d";
import vehicleApi from "src/api/vehicleApi";
import { IVehicle } from "src/models/vehicle";
import { IPaging } from "src/models/paging";

export class VehicleStore implements IVehicleStore {
  isLoading: boolean = false;
  vehicles: IPaging<IVehicle> = null;
  vehicleDetail: IVehicle = null;
  filter: any;

  constructor() {
    makeAutoObservable(this);
  }

  async postVehicle(vehicleData: IVehicle) {
    try {
      this.isLoading = true;
      const res = await vehicleApi.postVehicle(vehicleData);
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateVehicle(_id: string, vehicleData: IVehicle) {
    try {
      this.isLoading = true;
      const res = await vehicleApi.updateVehicle(_id, vehicleData);
      return res;
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }

  async getVehicleApi(filter: any) {
    try {
      this.isLoading = true;

      let queryString = "?";
      Object.keys(filter).forEach((element) => {
        if (filter[element]) {
          queryString += `${element}=${filter[element]}&`;
        }
      });
      queryString = queryString.slice(0, -1);

      const res: IPaging<IVehicle> = await vehicleApi.getVehicles(queryString);
      this.setVehicles(res);
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }
  setVehicles(vehicles?: IPaging<IVehicle>) {
    this.vehicles = vehicles;
  }
  getVehicles() {
    return toJS(this.vehicles);
  }

  async getVehicleById(_id: string) {
    try {
      this.isLoading = true;
      const res: IVehicle = await vehicleApi.getVehicleById(_id);
      this.setVehicleDetail(res);
    } catch (error) {
      console.log("========= error: ", error);
    } finally {
      this.isLoading = false;
    }
  }
  setVehicleDetail(vehicle?: IVehicle) {
    this.vehicleDetail = vehicle;
  }
  getVehicleDetail() {
    return toJS(this.vehicleDetail);
  }

  setFilter(filter: any) {
    this.filter = filter;
  }
  getFilter() {
    return toJS(this.filter);
  }
}

export default new VehicleStore();
